import type { TranslateDictionary } from './en.js';

export const Ru: TranslateDictionary = {
  'Start airplay': 'Начать AirPlay',
  'Stop airplay': 'Остановить AirPlay',
  Audio: 'Аудио',
  Captions: 'Подписи',
  'Enable captions': 'Включить подписи',
  'Disable captions': 'Выключить подписи',
  'Start casting': 'Начать трансляцию',
  'Stop casting': 'Остановить трансляцию',
  'Casting to {device}': 'Трансляция на {device}',
  'Enter fullscreen mode': 'На полный экран',
  'Exit fullscreen mode': 'Выйти из полного экрана',
  Mute: 'Выключить звук',
  Unmute: 'Включить звук',
  'Enter picture in picture mode': 'Включить режим картинка-в-картинке',
  'Exit picture in picture mode': 'Выйти из режима картинка-в-картинке',
  Play: 'Воспроизвести',
  Pause: 'Приостановить',
  'Playback rate': 'Скорость воспроизведения',
  'Playback rate {playbackRate}': 'Скорость воспроизведения {playbackRate}',
  Quality: 'Качество',
  'Seek backward': 'Перемотать назад',
  'Seek forward': 'Перемотать вперед',
  Settings: 'Настройки',
  Auto: 'Авто',
  'audio player': 'аудио плеер',
  'video player': 'видео плеер',
  volume: 'Громкость',
  seek: 'Искать',
  'closed captions': 'Подписи',
  'current playback rate': 'текущая скорость воспроизведения',
  'playback time': 'время воспроизведения',
  'media loading': 'загрузка медиа',
  settings: 'Настройки',
  'audio tracks': 'аудиодорожки',
  quality: 'Качество',
  play: 'воспроизвести',
  pause: 'приостановить',
  mute: 'выключить звук',
  unmute: 'включить звук',
  'chapter: {chapterName}': 'глава: {chapterName}',
  live: 'прямой эфир',
  Off: 'Выключено',
  'start airplay': 'начать AirPlay',
  'stop airplay': 'остановить AirPlay',
  'start casting': 'начать трансляцию',
  'stop casting': 'остановить трансляцию',
  'enter fullscreen mode': 'на полный экран',
  'exit fullscreen mode': 'выйти из полного экрана',
  'enter picture in picture mode': 'включить режим картинка-в-картинке',
  'exit picture in picture mode': 'выйти из режима картинка-в-картинке',
  'seek to live': 'перейти к прямому эфиру',
  'playing live': 'воспроизведение в прямом эфире',
  'seek back {seekOffset} seconds': 'перемотать на {seekOffset} с назад',
  'seek forward {seekOffset} seconds': 'перемотать на {seekOffset} с вперед',
  'Network Error': 'Ошибка сети',
  'Decode Error': 'Ошибка декодирования',
  'Source Not Supported': 'Источник не поддерживается',
  'Encryption Error': 'Ошибка шифрования',
  'A network error caused the media download to fail.':
    'Ошибка сети привела к сбою загрузки медиа.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Ошибка медиа привела к прерыванию воспроизведения. Медиа может быть повреждено или ваш браузер не поддерживает этот формат.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Произошла неподдерживаемая ошибка. Сервер или сеть не работают, или ваш браузер не поддерживает этот формат.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Медиа зашифровано и нет ключей для его расшифровки.',
};
